module.exports = __webpack_public_path__ + "static/media/motor-main-banner.69dbd194.svg";